import { Bar } from 'vue-chartjs';
export default {
    extends: Bar,

    props: ['chartdataLabels', 'chartdataSets', 'max-Ticks', 'xStacked', 'yStacked'],

    data() {
        return {
            chartdata: {
                labels: this.chartdataLabels,
                datasets: this.chartdataSets,
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                // max: this.maxTicks < 10 ? 10 : this.maxTicks,
                                min: 0,
                                stepSize: 2,
                                beginAtZero: true,
                            },
                            stacked: this['yStacked'] != null ? this['yStacked'] : true,
                        }
                    ],
                    xAxes: [
                        {
                            ticks: {
                                autoSkip: false,
                                maxRotation: 60,
                                minRotation: 60,
                            },
                            stacked: this['xStacked'] != null ? this['xStacked'] : true,
                        },
                    ],
                },
            },
        };
    },

    mounted() {
        if (this.chartdata.datasets.length && this.chartdata.labels.length) {
            this.renderChart(this.chartdata, this.options);
        }
    },
    watch: {
        chartdataSets(val) {
            if (val) {
                this.chartdata.datasets = val;
                this.renderChart(this.chartdata, this.options);
            }
        },
        chartdataLabels(val) {
            if (val) {
                this.chartdata.labels = val;
                this.renderChart(this.chartdata, this.options);
            }
        },
    },
};
